// for unassigment of employee
export const RESET_GET_EMPLOYEE_SALARIES = "resign_get_employees_salaries";
export const GET_EMPLOYEE_SALARIES = "get_employees_salaries";
export const GET_EMPLOYEE_SALARIES_SUCCESS = "get_employees_salaries_success";
export const GET_EMPLOYEE_SALARIES_FAILURE = "get_employees_salaries_failure";
